/**
 * Extrai o nome do arquivo a partir do header `Content-Disposition`.
 *
 * O valor de `filename` vem URL-encoded (ex.: `arquivo%20final.csv`), portanto
 * aplicamos `decodeURIComponent`. Suporta tanto `filename="..."` quanto o
 * formato estendido `filename*=UTF-8''...`.
 *
 * Caso o header não venha, não seja legível ou o decode falhe, retorna o
 * `fallbackFileName` informado (o front já conhece `name`/`extension` do File
 * via `GET /files/:id`).
 */
export const getFileNameFromContentDisposition = (
  contentDisposition?: string | null,
  fallbackFileName?: string,
): string | undefined => {
  if (contentDisposition) {
    const extendedMatch = contentDisposition.match(/filename\*=(?:UTF-8'')?"?([^";]+)"?/i);
    const simpleMatch = contentDisposition.match(/filename="?([^";]+)"?/i);
    const rawFileName = extendedMatch?.[1] ?? simpleMatch?.[1];

    if (rawFileName) {
      try {
        return decodeURIComponent(rawFileName.trim());
      } catch {
        return rawFileName.trim();
      }
    }
  }

  return fallbackFileName;
};
